import { get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { RunwayContribution } from '../../../../components/widgets/airport/runways/runways-contribution/runway-contribution';
import { connectNLP } from '../../../../utilities/connect-navigate';
import { Contributions } from './contributions';

const mapStateProps = (store: any) => ({
	user: store.user.user,
});

const mapDispatchProps = (dispatch: any) => ({});

class RunwayContributionsComponent extends Contributions<any, any> {
	public endpoint(): any {
		const user = get(this.props, 'user');
		const userRoles = get(user, 'roles');
		const isAdmin = userRoles.includes('ADMIN');
		const system = get(this.props, 'system');
		const systemInfo = system === true ? '/system' : `/users/${system}`;
		const otherInfo = isAdmin ? '' : `/users/${get(user, 'aid')}`;

		const systemAdminOrGeneral = isAdmin && system ? systemInfo : otherInfo;

		return `/runways/contributions${systemAdminOrGeneral}`;
	}

	public getType(): string {
		return 'runways';
	}

	public getModalEndpoint() {
		return `/runways/${get(this.state.item, 'entityAid')}`;
	}

	public renderModalContent(ctx): React.ReactElement {
		return (
			<RunwayContribution
				item={this.state.item}
				onSuccess={() => this.handleModalSuccess()}
				original={get(ctx.state, 'response')}
				close={() => this.onModalClose()}
			/>
		);
	}
}

export const RunwayContributions: any = connect(
	mapStateProps,
	mapDispatchProps,
	null,
	{ forwardRef: true }
)(connectNLP(RunwayContributionsComponent));
